import React from 'react'
import Container from '@material-ui/core/Container'
import makeStyles from '@material-ui/core/styles/makeStyles'
import StoreReviewItem from './StoreReviewItem'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme) => ({
    container: {
        backgroundColor: '#FFFFFF',
        width: '100%',
        padding: '2.5rem 0',
        display: 'flex',
        flexDirection: 'column',
        rowGap: '1rem',
        alignItems: 'center',
        [theme.breakpoints.up('sm')]: {
            padding: '2.5rem 2rem',
        },
        [theme.breakpoints.up('md')]: {
            padding: '4rem 5rem',
        },
    },
    listContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        rowGap: '1rem',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        },
    },
    header: {
        fontSize: '1.65rem',
        fontWeight: 'bold',
        margin: '0 0 1rem 0',
        [theme.breakpoints.up('md')]: {
            fontSize: '2rem',
        },
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            marginLeft: '1rem',
            marginRight: '1rem',
        },
    },
}))

const StoreReviewList = ({ fullWidth, hideHeader }) => {
    const classes = useStyles()
    const storeReviewListRaw = window.React?.storeReviewList
    if (!storeReviewListRaw) {
        return null
    }

    const storeReviewList = JSON.parse(storeReviewListRaw)
    if (!storeReviewList || !Array.isArray(storeReviewList)) {
        return null
    }

    return (
        <Container
            maxWidth={fullWidth ? false : 'lg'}
            className={classes.container}
        >
            {!hideHeader && (
                <Typography variant="h2" className={classes.header}>
                    What our customers are saying about our gift cards
                </Typography>
            )}
            <div className={classes.listContainer}>
                {storeReviewList.map((item, index) => {
                    return (
                        <StoreReviewItem
                            key={index}
                            name={item.name}
                            logo={item.logo}
                            rating={item.rating}
                            ratingsCount={item.ratingsCount}
                            url={item.url}
                        />
                    )
                })}
            </div>
        </Container>
    )
}

export default StoreReviewList
